/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Link } from 'gatsby';
import ImageGallery from 'react-image-gallery';

import { Section, Layout, SEO, BuyButton, PromoVideoModal, StoreBadge } from '..';
import { External } from '../icons';
import { FaqSection } from './FaqSection';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

import style from './WebGameUnboxingPage.module.less';

import hero from './assets/hero.jpg';
import stefan from './assets/stefan.png';
import ally from './assets/ally.png';
import teamBuilding from './assets/teambuilding.jpg';
import unboxing from './assets/unboxing.png';

// reviewers
import escapemattster from './assets/escapemattster.jpg';
import escaperoomer from './assets/escaperoomer.png';
import escapetheroomers from './assets/escapetheroomers.jpg';
import reviewtheroom from './assets/reviewtheroom.jpg';
import escapegoats from './assets/escapegoats.png';
import borderlinepuzzler from './assets/borderlinepuzzler.jpg';
import chaos from './assets/chaos.png';
import puzzlingCompany from './assets/puzzlingcompany.png';

// blocks
import browser from './assets/browser.png';
import players from './assets/players.png';
import difficulty from './assets/difficulty.png';
import time from './assets/time.png';
import accessibility from './assets/accessibility.png';
import age from './assets/age.png';

// screenshots
import screenshot1 from './assets/screenshot1.jpg';
import screenshot2 from './assets/screenshot2.jpg';
import screenshot3 from './assets/screenshot3.jpg';
import screenshot4 from './assets/screenshot4.jpg';
import screenshot5 from './assets/screenshot5.jpg';
import screenshot6 from './assets/screenshot6.jpg';

// awards
import awardETRBestDigitalGame from './assets/2021_Best_Digital_Game.png';
import awardETRFinalist from './assets/2021_FINALIST.png';

const screenshots = [
  { original: screenshot1 },
  { original: screenshot2 },
  { original: screenshot3 },
  { original: screenshot4 },
  { original: screenshot5 },
  { original: screenshot6 }
];

export const WebGameUnboxingPage = () => (
  <Layout transparentTop={true}>
    <SEO
      title="Unboxing the mind of a Cryptic Killer"
      description="Two detectives fall into Cryptic Killer's trap. They only have a walkie-talkie, their wits and 90 minutes to escape."
      image={unboxing}
    />

    <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
      <div className={style.wrapper}>
        <div className={style.device}>
          <PromoVideoModal />
        </div>
        <div className={style.game}>
          <h1>Unboxing the mind<br />of a Cryptic Killer</h1>
          <p className={style.tagname}>
            Two detectives fall into Cryptic Killer's trap.
            <br />
            They only have a walkie-talkie, their wits
            <br />
            and 90 minutes to escape.
          </p>
          <BuyButton placement="Hero" product="unboxing" text="BUY WEB VERSION" />
          <p className={style.priceNote}>Price for a team</p>
          {/* <p className={style.saleNote}>20% Halloween Sale <br /> Ends midnight 7 Nov 2021 (CET)</p> */}
          <p className={style.gotAccessCode}>Got a License Key? <a href="https://game.elevenpuzzles.com?from=website" target="_blank" rel="noreferrer">Click here <External /></a></p>
        </div>
      </div>
    </Section>

    <Section className={style.steam}>
      <h1>Looking for a PC, Mac, iOS or Android version?</h1>
      <div className={style.row}>
        <div className={style.content}>
          <div className={style.learnMoreWrapper}>
            <Link className={style.learnMore} to="/unboxing-the-cryptic-killer">Learn more →</Link>
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.screenshots} alternate={true}>
      <h1>Game screenshots</h1>
      <ImageGallery
        additionalClass={style.gallery}
        items={screenshots}
        showNav={true}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={false}
      />
    </Section>

    <Section className={style.requirements}>
      <h1>Game requirements & details</h1>
      <div className={style.blocks}>
        <div className={style.block}>
          <img src={browser} alt="Browser" />
          <h3>Modern browser</h3>
          <p>The game requires only a modern browser, no need to install anything!</p>
        </div>
        <div className={style.block}>
          <img src={players} alt="Players" />
          <h3>2-6 players</h3>
          <p>The game requires 2 teams and each team needs a separate device.</p>
        </div>
        <div className={style.block}>
          <img src={age} alt="Age" />
          <h3>Over 7 years old</h3>
          <p>The game is family friendly but the puzzles can be challenging for little ones. Make sure an adult is on their team!</p>
        </div>
        <div className={style.block}>
          <img src={time} alt="Time" />
          <h3>Around 90 minutes</h3>
          <p>Depending on your puzzle-solving experience this may vary.</p>
        </div>
        <div className={style.block}>
          <img src={difficulty} alt="Difficulty" />
          <h3>3 / 5 difficulty level</h3>
          <p>Don’t worry, you can always use a clue if you’re stuck. No judgement here!</p>
        </div>
        <div className={style.block}>
          <img src={accessibility} alt="Accessibility" />
          <h3>Limited accessibility</h3>
          <p>Sadly, the game is not suitable for people with colour blindness, deafness or HOH. We still welcome you to play with the help of your teammates.</p>
        </div>
      </div>
    </Section>

    <Section className={style.testimonials} alternate={true}>
      <div className={style.content}>
        <h1>What reviewers are saying about the game?</h1>
        <div className={style.row}>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>Superb online puzzles don't come by every day, and one under the co-op category is even harder to find. And yet luckily, the return of the Cryptic Killer brings us exactly that. And possibly more carnage. Aw, well. You win some, you lose some.</p>
            </div>
            <img src={escapemattster} alt="Escape Mattster" className={style.avatar} />
            <p className={style.name}>Escape Mattster</p>
            <p className={style.readMore}><a href="https://www.escapemattster.com/post/unboxing" target="_blank">Read the full review <External /></a></p>
          </div>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>I’m just surprised this game isn’t at well known as it is! It’s a hidden gem for sure and one I’d highly recommend for a couples night in, or reconnecting with a friend via Zoom to puzzle it out for 90 minutes. But which character will you choose to be? Pick wisely!</p>
            </div>
            <img src={escaperoomer} alt="The Escape Room-er" className={style.avatar} />
            <p className={style.name}>The Escape Room-er</p>
            <p className={style.readMore}><a href="https://theescaperoomer.com/eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer/" target="_blank">Read the full review <External /></a></p>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>I think we've found our first favorite cooperative puzzle game in 2021!  This game really bought out the teamwork aspect through the puzzles and game design. We can't wait to see what Eleven Puzzles will be able to whip up in the near future!</p>
            </div>
            <img src={escapetheroomers} alt="ESCAPETHEROOMers" className={style.avatar} />
            <p className={style.name}>ESCAPETHEROOMers</p>
            <p className={style.readMore}><a href="https://www.escapetheroomers.com/post/eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer" target="_blank">Read the full review <External /></a></p>
          </div>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>The more I look back on this game, the more I realise how much I enjoyed it.This game holds its’ own among the communication games by Enchambered (Alone Together & Together Apart), and if you like those, play this!</p>
            </div>
            <img src={reviewtheroom} alt="Review The Room" className={style.avatar} />
            <p className={style.name}>Review The Room</p>
            <p className={style.readMore}><a href="https://www.reviewtheroom.co.uk/eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer-play-at-home/" target="_blank">Read the full review <External /></a></p>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>This is one of the better value games I’ve played for the simple fact that it is a truly cooperative game. That would mean nothing however if the rest of the game was lacking but, luckily, ‘Unboxing the Mind of a Cryptic Killer’ is firing on all cylinders!</p>
            </div>
            <img src={escapegoats} alt="Escape Goats" className={style.avatar} />
            <p className={style.name}>Escape Goats</p>
            <p className={style.readMore}><a href="https://www.escapegoatsuk.com/eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer-review" target="_blank">Read the full review <External /></a></p>
          </div>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>Overall, this was an amazing first offering from Eleven Puzzles. I really can’t wait to see their work continue and it’s made me really excited to start my own journey in online escape room development, so thank you!</p>
            </div>
            <img src={borderlinepuzzler} alt="Borderline Puzzler" className={style.avatar} />
            <p className={style.name}>Borderline Puzzler</p>
            <p className={style.readMore}><a href="https://borderlinepuzzler.com/2021/02/14/eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer/" target="_blank">Read the full review <External /></a></p>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>If you decide to dive into “Unboxing the Mind of a Cryptic Killer,” we hope you have as much fun as we did.  Happy hunting, detectives!</p>
            </div>
            <img src={chaos} alt="Chaos & Confetti" className={style.avatar} />
            <p className={style.name}>Chaos & Confetti</p>
            <p className={style.readMore}><a href="https://chaosyconfetti.com/2021/12/28/review-eleven-puzzles-unboxing-the-mind-of-a-cryptic-killer/" target="_blank">Read the full review <External /></a></p>
          </div>
          <div className={style.testimonial}>
            <div className={style.quote}>
              <p>Eleven Puzzles nails the split team experience. Can't wait to see what they cook up next.</p>
            </div>
            <img src={puzzlingCompany} alt="Puzzling Company" className={style.avatar} />
            <p className={style.name}>Puzzling Company Podcast</p>
            <p className={style.readMore}><a href="https://puzzlingcompany.com/" target="_blank">Listen to the podcast <External /></a></p>
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.awards}>
      <div className={style.content}>
        <h1>Awards</h1>
        <div className={style.row}>
          <div className={style.award}>
            <img src={awardETRBestDigitalGame} alt="Best Digital Game" />
          </div>
          <div className={style.award}>
            <img src={awardETRFinalist} alt="People Choice" />
          </div>
        </div>
      </div>
    </Section>

    <FaqSection />

    <Section className={style.gameCharacters} alternate={false}>
      <div className={style.content}>
        <h1>Meet the game characters</h1>
        <div className={style.row}>
          <div className={style.stefan}>
            <img src={stefan} alt="Old Dog" />
          </div>
          <div className={style.stefanDescription}>
            <h2>Stefan "Old Dog" Kowalski</h2>
            <p className={style.location}>Krakow, Poland</p>
            <p>Old dog has always appeared older and wiser than his years, from an early age he wanted to work in law enforcement and achieved his dreams when accepted into the Polish police force.</p>
            <p>His successes started before his training was even complete and never really stopped. That was until he was assigned to work with Ally on an international hunt for the Cryptic Killer that ended up becoming his white whale.</p>
            <p>Essentially a loner, Old dog spends his nights listening to jazz music and drinking coffee as he obsesses over the details of the decade old cold case.</p>
            <p><Link to="/the-story">Read more →</Link></p>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.ally}>
            <img src={ally} alt="Ally" />
          </div>
          <div className={style.allyDescription}>
            <h2>Allison Abernathy ("Ally" for short)</h2>
            <p className={style.location}>Glasgow, Scotland</p>
            <p>Ally grew up in a police family and was always destined to join the police force. When Ally puts her mind to something she achieves it and lets nothing get in her way.</p>
            <p>Her streak of success as a detective, was interrupted when she worked with the Polish police to investigate the Cryptic Killer case. It was then that she was seriously injured and the perpetrator fled.</p>
            <p>Since returning to the services, after recovering from her injures, she now deals with smaller, less complex cases. However, she is still a determined detective and uncompromising investigator.</p>
            <p><Link to="/the-story">Read more →</Link></p>
          </div>
        </div>
      </div>
    </Section>

    <Section alternate={true} className={style.teamBuilding}>
      <div className={style.content}>
        <h1>Virtual team building or a large group?</h1>
        <div className={style.chart}>
          <img src={teamBuilding} alt="Team Building" />
          <p style={{ marginTop: '2rem' }}>The game has been used as a team-building exercise on several occasions, and feedback has been very positive!</p>
        </div>
        <div className={style.row}>
          <div className={style.description}>
            <h2>It's a great bonding experience!</h2>
            <p>The game is designed heavily around communication. This keeps everyone engaged and actively participating! TEAMWORK and COMMUNICATION are the key to success. The game is accessible for players of any experience level. Both beginners and experienced players can enjoy the game equally.</p>

            <h2>How many players can play?</h2>
            <p>There is virtually no limit, but players will have to be divided into smaller groups (we recommend 4-6 players). To date, the biggest group playing the game simultaneously was over 100 players (split into 30+ teams), but our servers can handle up to 1 Million.</p>
          </div>
          <div className={style.description}>
            <h2>How to host a team building event?</h2>
            <p>It's very easy:</p>
            <ol>
              <li>Divide your team into groups of 2-6 players</li>
              <li>Establish a communication channel for each group (Zoom, Google Meet, Skype, etc.)</li>
              <li>Give each group one of the purchased access codes and a link</li>
              <li>Let them have fun!</li>
            </ol>
          </div>
        </div>
        <div className={style.summary}>
          <p>If you have any questions, please check our <Link to="/web-games/faq">FAQ section</Link> or <Link to="/contact">contact us</Link>.</p>
        </div>
      </div>
    </Section>

    <Section className={style.buy2}>
      <div className={style.content}>
        <h1>Buy today, play later</h1>
        <p>
          It's not a physical escape room, so no booking needed.
          <br />
          Play anytime so long as it’s within a year from the date of purchase.
        </p>
        <BuyButton placement="Buy2" product="unboxing" />
      </div>
    </Section>
  </Layout>
);
